'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StarRating = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _reactIntl = require('react-intl');

var _starRounded = require('../../../static/img/icon/star-rounded.svg');

var _starRounded2 = _interopRequireDefault(_starRounded);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fiveStarRender = function fiveStarRender(_ref) {
  var rating = _ref.rating,
      stars = _ref.stars,
      count = _ref.count;
  return _react2.default.createElement(
    _react.Fragment,
    null,
    stars,
    rating,
    count
  );
};

fiveStarRender.propTypes = {
  rating: _propTypes2.default.node,
  stars: _propTypes2.default.node,
  count: _propTypes2.default.node
};

var singleStarRender = function singleStarRender(_ref2) {
  var rating = _ref2.rating,
      stars = _ref2.stars,
      count = _ref2.count;
  return _react2.default.createElement(
    _react.Fragment,
    null,
    rating,
    stars,
    count
  );
};

singleStarRender.propTypes = {
  rating: _propTypes2.default.node,
  stars: _propTypes2.default.node,
  count: _propTypes2.default.node
};

var StarRating = exports.StarRating = function StarRating(_ref3) {
  var rating = _ref3.rating,
      showRatingNumber = _ref3.showRatingNumber,
      count = _ref3.count,
      className = _ref3.className,
      singleStar = _ref3.singleStar,
      children = _ref3.children;

  var ratingComponent = null;
  if (showRatingNumber && rating > 0) {
    ratingComponent = _react2.default.createElement(
      'span',
      { className: 'ratings__rating ratings--child' },
      _react2.default.createElement(_reactIntl.FormattedNumber, {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
        value: rating
      })
    );
  }

  var starsComponent = void 0;
  if (singleStar) {
    starsComponent = _react2.default.createElement(
      'div',
      { className: 'ratings__stars-container ratings--child' },
      _react2.default.createElement(_reactInlinesvg2.default, { className: 'ratings__star-icon ratings--star-icon-single', src: _starRounded2.default })
    );
  } else {
    starsComponent = _react2.default.createElement(
      'div',
      { className: 'ratings__stars-container ratings--child' },
      _react2.default.createElement(
        'div',
        { className: 'ratings__stars-off' },
        _react2.default.createElement(_reactInlinesvg2.default, { className: 'ratings__star-icon', src: _starRounded2.default }),
        _react2.default.createElement(_reactInlinesvg2.default, { className: 'ratings__star-icon', src: _starRounded2.default }),
        _react2.default.createElement(_reactInlinesvg2.default, { className: 'ratings__star-icon', src: _starRounded2.default }),
        _react2.default.createElement(_reactInlinesvg2.default, { className: 'ratings__star-icon', src: _starRounded2.default }),
        _react2.default.createElement(_reactInlinesvg2.default, { className: 'ratings__star-icon', src: _starRounded2.default })
      ),
      _react2.default.createElement(
        'div',
        { className: 'ratings__stars-on', style: { width: Math.round(rating * 2) * 10 + '%' } },
        _react2.default.createElement(_reactInlinesvg2.default, { className: 'ratings__star-icon', src: _starRounded2.default }),
        _react2.default.createElement(_reactInlinesvg2.default, { className: 'ratings__star-icon', src: _starRounded2.default }),
        _react2.default.createElement(_reactInlinesvg2.default, { className: 'ratings__star-icon', src: _starRounded2.default }),
        _react2.default.createElement(_reactInlinesvg2.default, { className: 'ratings__star-icon', src: _starRounded2.default }),
        _react2.default.createElement(_reactInlinesvg2.default, { className: 'ratings__star-icon', src: _starRounded2.default })
      )
    );
  }

  var countComponent = null;
  if (parseInt(String(count).replace(/[^\d]/g, ''), 10) > 0) {
    countComponent = _react2.default.createElement(
      'span',
      { className: 'ratings__count ratings--child' },
      '(',
      typeof count === 'number' ? _react2.default.createElement(_reactIntl.FormattedNumber, { value: count }) : count,
      ')'
    );
  }

  var render = void 0;
  if (typeof children === 'function') {
    render = children;
  } else if (singleStar) {
    render = singleStarRender;
  } else {
    render = fiveStarRender;
  }

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('ratings ratings--display', className) },
    render({ rating: ratingComponent, stars: starsComponent, count: countComponent })
  );
};

StarRating.propTypes = {
  rating: _propTypes2.default.number.isRequired,
  className: _propTypes2.default.string,
  showRatingNumber: _propTypes2.default.bool,
  count: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  singleStar: _propTypes2.default.bool,
  children: _propTypes2.default.func
};